const $ = require('jquery');
const i18next = require('i18next');

const Ui = require('./Ui');
const constants = require('../data/constants');
const Countries = require('./countries');
const Utils = require('./MappingUtils');

class AddressRouting {
  /**
   *
   * @param {IWMap} map
   * @param {IWGeocoderClient} geocoder
   * @param {Preloader}  preloader
   */
  constructor(map, geocoder, preloader, storage, sessionId) {
    this.map = map;
    this.preloader = preloader;
    this.geocoder = geocoder;
    this.storage = storage;

    this.countries = new Countries();

    this.modal = $('.modal-routing');
    this.startAddressInput = $('#routingFormStartAddress');
    this.countrySelectorStart = $("#countrySelectorStart");
    this.endAddressInput = $('#routingFormEndAddress');
    this.countrySelectorEnd = $("#countrySelectorEnd");
    this.formElement = $('#routingForm');
    this.submitButton = $('#routingSubmit');
    this.mapContextMenu = $('#routing-context-menu');
    this.routeContextMenu = $("#current-route-context-menu");
    this.truckAttributesRouting = $('#truck-attributes');
    this.latestRouteCoords = null;
    this.latestRouteData = null;
    this.latestClick = null;
    this.rightClickInfo = null;
    this.startMarker = null;
    this.destinationMarker = null;
    this.emergencyCircle = null;
    this.totalGeocodedAddress = 0;

    this.useEmergencyRouting = false;
    this.emergencyRadius = 0;

    this.isStartAddressSet = false;
    this.latestStartAddress = null;
    this.isDestinationAddressSet = false;
    this.latestDestinationAddress = null;
    this.isRoutingTriggeredViaForm = false;

    this.regex = /[a-zA-Z]/;

    IWRoutingManager.setToken(sessionId);

    this.circleAttributes = {
      fill: 'blue',
      fillOpacity: 0.5,
      stroke: 'black',
      strokeOpacity: 0.5,
      strokeWidth: 2
    };
  }

  init() {
    return new Promise ((resolve, reject) => {
      this.addListeners();
      this.populateCountriesList();
      this.updateEmergencyRoutingData()
        .then(() => {
          resolve();
        });
    })
  }

  initRouting(checkForExistingRoute) {
    if(checkForExistingRoute && this.totalGeocodedAddress < 2) return;

    this.preloader.showCursorPreloader();
    if(this.emergencyCircle) {
      IWRoutingManager._renderer.removeElement(this.emergencyCircle);
      this.emergencyCircle = null;
    }

    this.isRoutingTriggeredViaForm = true;

    this.updateEmergencyRoutingData()
      .then(() => {

        const addressStart = new IWAddressString();
        if(this.regex.test(this.startAddressInput.val())) {
          // noinspection JSCheckFunctionSignatures
          addressStart.setAddress(this.startAddressInput.val());
          addressStart.setCountry(this.countrySelectorStart.val());
          addressStart.setIso3166Code(this.countrySelectorStart.val());
          if(this.startAddressInput.data('x-coord')) {
            let coord = new IWCoordinate(this.startAddressInput.data('x-coord'), this.startAddressInput.data('y-coord'));
            addressStart.setCoordinate(coord);
          }
        } else {
          const coordinatesStart = this.startAddressInput.val().split(',');

          let coordinateType = IWCoordinate.MERCATOR;
          if(coordinatesStart[0] < 180 && coordinatesStart[0] > -180 && coordinatesStart[1] < 90 && coordinatesStart[1] > -90) {
            coordinateType = IWCoordinate.WGS84;
          }
          let coord = new IWCoordinate(coordinatesStart[1],coordinatesStart[0], coordinateType);

          addressStart.setAddress(this.startAddressInput.val());
          addressStart.setCoordinate(coord);
        }

        const addressEnd = new IWAddressString();
        if(this.regex.test(this.endAddressInput.val())) {
          // noinspection JSCheckFunctionSignatures
          addressEnd.setAddress(this.endAddressInput.val());
          addressEnd.setCountry(this.countrySelectorEnd.val());
          addressEnd.setIso3166Code(this.countrySelectorEnd.val());
          if(this.endAddressInput.data('x-coord')) {
            let coord = new IWCoordinate(this.endAddressInput.data('x-coord'), this.endAddressInput.data('y-coord'));
            addressEnd.setCoordinate(coord);
          }
        } else {
          const coordinatesStart = this.endAddressInput.val().split(',');

          let coordinateType = IWCoordinate.MERCATOR;
          if(coordinatesStart[0] < 180 && coordinatesStart[0] > -180 && coordinatesStart[1] < 90 && coordinatesStart[1] > -90) {
            coordinateType = IWCoordinate.WGS84;
          }
          let coord = new IWCoordinate(coordinatesStart[1],coordinatesStart[0], coordinateType);

          addressEnd.setAddress(this.endAddressInput.val());
          addressEnd.setCoordinate(coord);
        }

        IWRoutingManager.updateStart(addressStart, false, false);
        this.latestStartAddress = addressStart;
        IWRoutingManager.updateDestination(addressEnd, false, false);
        this.latestDestinationAddress = addressEnd;
        IWRoutingManager.geocodeAddresses();
      });

  }

  parseGeocodingResults(results) {
    const { addresses } = results;
    const errors = [];
    this.totalGeocodedAddress = 0;

    if (addresses.start.length === 0) {
      errors.push(i18next.t('errors.could-not-find-start-address'));
    }

    if (addresses.destination.length === 0) {
      errors.push(i18next.t('errors.could-not-find-end-address'));
    }

    if (errors.length > 0) {
      Ui.showModalError(errors.join('<br />'));
      return;
    }

    if (addresses.start.length === 1) {
      this.setStartAddress(
        window.IWRoutingUtils.getAddressFromObject(addresses.start[0]),
        null,
        false,
      );
    }

    if (addresses.start.length > 1) {
      this.showAddressDisambiguation('start', addresses.start);
    }

    if (addresses.destination.length === 1) {
      this.setEndAddress(
        window.IWRoutingUtils.getAddressFromObject(addresses.destination[0]),
        null,
        false,
      );
    }

    if (addresses.destination.length > 1) {
      this.showAddressDisambiguation('end', addresses.destination);
    }

    this.preloader.hideCursorPreloader();
  }

  /**
   * @param type
   * @param {IWAddress[]} addresses
   */
  showAddressDisambiguation(type, addresses) {
    $('#routingMultipleAddressesFoundWarning').show();
    let container = null;
    if (type === 'start') {
      container = $('#routing-results-disambiguation-container-start');
    } else if (type === 'end') {
      container = $('#routing-results-disambiguation-container-end');
    }

    container.find('a').remove();

    /**
     * @type {IWAddress} rawAddress
     */
    addresses.forEach((rawAddress) => {
      // noinspection JSUnresolvedVariable
      const hitProbability = rawAddress.probability;
      const address = window.IWRoutingUtils.getAddressFromObject(rawAddress);
      const listItem = $('<a href="#" class="list-group-item list-group-item-action"></a>');

      let cityPart = rawAddress.cityPart ? '- ' + rawAddress.cityPart : '';

      listItem.html(`<strong>${address.toFormattedString()} ${cityPart}</strong> <em>(${i18next.t('general.relevance')}: ${hitProbability}%)</em>`);

      listItem.on('click', (element) => {
        if (type === 'start') {
          this.setStartAddress(address, null, true);
        } else if (type === 'end') {
          this.setEndAddress(address, null, true);
        }
        element.preventDefault();
      });

      listItem.appendTo(container.find('.list-group'));
    });

    container.show();
  }

  setStartAddress(address, abstractAddress, doZoom) {
    if (this.startMarker) {
      this.removeMarkerFromMap(this.startMarker);
    }

    let useAddress = address;

    if (abstractAddress) {
      useAddress = abstractAddress;
      this.startAddressInput.data('x-coord', abstractAddress.getCoordinate()._x);
      this.startAddressInput.data('y-coord', abstractAddress.getCoordinate()._y);
    } else {
      this.startAddressInput.data('x-coord', address.getCoordinate()._x);
      this.startAddressInput.data('y-coord', address.getCoordinate()._y);
    }

    this.startMarker = this.addMarkerOnMap(useAddress, 'start-map-marker.svg');

    IWRoutingManager.updateStart(useAddress, false, false);
    this.latestStartAddress = useAddress;

    if(address){
      this.startAddressInput.val(address.toFormattedString());
    } else {
      this.startAddressInput.val(abstractAddress.getCoordinate());
    }
    if(!this.isStartAddressSet || this.isRoutingTriggeredViaForm) this.totalGeocodedAddress += 1;

    this.checkTotalGeocodedAddresses(doZoom);

    this.isStartAddressSet = true;
  }

  setEndAddress(address, abstractAddress, doZoom) {
    if (this.destinationMarker) {
      this.removeMarkerFromMap(this.destinationMarker);
    }

    let useAddress = address;

    if (abstractAddress) {
      useAddress = abstractAddress;
      this.endAddressInput.data('x-coord', abstractAddress.getCoordinate()._x);
      this.endAddressInput.data('y-coord', abstractAddress.getCoordinate()._y);
    } else {
      this.endAddressInput.data('x-coord', address.getCoordinate()._x);
      this.endAddressInput.data('y-coord', address.getCoordinate()._y);
    }

    this.updateEmergencyRoutingData()
      .then(() => {
        if(this.useEmergencyRouting) {
          this.emergencyCircle = IWRoutingManager._renderer.drawCircle(useAddress.getCoordinate(), this.emergencyRadius, this.circleAttributes);
          IWRoutingManager._renderer.render();
          IWRoutingManager._renderer.moveToBottom(this.emergencyCircle);
        } else {
          this.emergencyCircle = null;
        }

        this.destinationMarker = this.addMarkerOnMap(useAddress, 'destination-map-marker.svg');

        IWRoutingManager.updateDestination(useAddress, false, false);
        this.latestDestinationAddress = useAddress;

        if(address) {
          this.endAddressInput.val(address.toFormattedString());
        } else {
          this.endAddressInput.val(abstractAddress.getCoordinate());
        }
        if(!this.isDestinationAddressSet || this.isRoutingTriggeredViaForm) this.totalGeocodedAddress += 1;
        this.checkTotalGeocodedAddresses(doZoom);

        this.isDestinationAddressSet = true;

      });

  }

  checkTotalGeocodedAddresses(doZoom) {
    if (this.totalGeocodedAddress < 2) {
      return;
    }

    this.setRouteOptions()
      .then(() => {

        this.preloader.showCursorPreloader();

        IWRoutingManager.calculateRoute(doZoom, false);
        IWRoutingManager.getRouteRenderer().moveToFront();

        this.isRoutingTriggeredViaForm = false;
        this.modal.modal('hide');

      });

  }

  addListeners() {
    /*
    $('#routingFormStartAddress, #routingFormEndAddress').on('input', () => {
      this.startAddressInput.removeData('x-coord');
      this.startAddressInput.removeData('y-coord');
      this.validateInput();
    });
    */

    $('#routingFormStartAddress').on('input', () => {
      this.startAddressInput.removeData('x-coord');
      this.startAddressInput.removeData('y-coord');
      this.validateInput();
    });

    $('#routingFormEndAddress').on('input', () => {
      this.endAddressInput.removeData('x-coord');
      this.endAddressInput.removeData('y-coord');
      this.validateInput();
    });

    this.formElement.on('submit', (event) => {
      if (this.validateInput()) {
        this.setRouteOptions();
        this.initRouting(false);
      } else {
        Ui.showModalError(i18next.t('errors.please-add-both-address'));
      }

      event.preventDefault();
    });

    this.modal.on('show.bs.modal', () => {
      $('#routingMultipleAddressesFoundWarning').hide();
      $('.routing-results-disambiguation').hide();

      this.fillTruckProfile();

      if (this.validateInput()) {
        this.modal.find('#routingSubmit').prop('disabled', false);
      }
    });

    this.countrySelectorStart.on('change', () => {
      this.storage.putOption("countrySelectorStart", this.countrySelectorStart.val());
    });
    this.countrySelectorEnd.on('change', () => {
      this.storage.putOption("countrySelectorEnd", this.countrySelectorEnd.val());
    });

    IWEventManager.addCustomListener(IWRoutingManager, 'oninputchecked', (results) => {
      this.parseGeocodingResults(results);
    });

    IWEventManager.addCustomListener(IWRoutingManager, 'onroute', (e) => {
      if(e.success) {
        this.latestRouteCoords = e.route.getCoordinates();
        this.latestRouteData = {drivingTime: e.route.getDrivingTime(), routeLength: e.route.getRouteLength()};

        const hrsDT = Math.floor((this.latestRouteData.drivingTime / 3600));
        const minsDT = Math.floor(((this.latestRouteData.drivingTime % 3600) / 60));
        const secsDT = Math.floor(this.latestRouteData.drivingTime % 60);

        let formatedTime = "";
        formatedTime += "" + hrsDT + ":" + (minsDT < 10 ? "0" : "");
        formatedTime += "" + minsDT + ":" + (secsDT < 10 ? "0" : "");
        formatedTime += "" + secsDT;

        let distance = this.latestRouteData.routeLength;
        if(distance >= 1000) {
          distance = distance/1000;
          distance = Math.round(distance * 100) / 100;
          distance += ' km';
        } else {
          distance += ' m';
        }

        this.latestRouteData["formattedDrivingTime"] = formatedTime;
        this.latestRouteData["formattedRouteLength"] = distance;
      } else {
        IWRoutingManager.clearRoute();
        Ui.showModalError(i18next.t('errors.could-not-calculate-route'));

        setTimeout(() => {

          if(this.latestStartAddress) {
            IWRoutingManager.updateStart(this.latestStartAddress, false, false);
          }

          if(this.latestDestinationAddress) {
            IWRoutingManager.updateDestination(this.latestDestinationAddress, false, false);
          }
        }, 50)

      }
      this.preloader.hideCursorPreloader();
    });

    IWEventManager.addCustomListener(this.geocoder, 'onreversegeocode', (event) => {
      const { type, triggeringPosition } = event.parameterObject;
      switch (type) {
        case constants.REVERSE_GEOCODING_RIGHT_CLICK_ON_MAP:
        default:
          if (triggeringPosition === this.latestClick && event.results.length > 0) {
            this.rightClickInfo.address = event.results[0].address;
            const currentText = this.mapContextMenu.find('#addressDetails').text();
            this.mapContextMenu.find('#addressDetails').html(
              Utils.getFormattedAddressName(event.results[0].address) + "<hr/>" + currentText,
            );

            $('#routing-add-start').removeClass('disabled');
            $('#routing-add-destination').removeClass('disabled');
          }
          break;
      }
    });

    IWEventManager.addCustomListener(IWRoutingManager.getRouteRenderer(), 'onrender', ()  => {
      if(!IWRoutingManager.getDisplayedRouteElement() || IWRoutingManager.getDisplayedRouteElement() === null) {
        return;
      }

      IWRoutingManager.getDisplayedRouteElement().shapes.forEach((shape) => {
        $(shape)
          .off('contextmenu')
          .on('contextmenu', (event) => {
            $('.editor-context-menu').hide();
            const deleteButton = this.routeContextMenu.find('#delete-route');
            const downloadButton = this.routeContextMenu.find('#download-route');

            deleteButton.off('click').on('click', (event) => {
              this.removeCurrentRoute();
            });

            downloadButton.off('click').on('click', (event) => {
              this.downloadRoute();
            });

            this.rightClickInfo = this.getClickInfo(event);
            const { x, y } = this.rightClickInfo.position;
            this.routeContextMenu.css({ left: x, top: y }).show();
          })
          .off('mouseenter')
          .on('mouseenter', (event) => {
            const coordinate = this.getClickInfo(event).coordinate;
            /*
            const hrsDT = Math.floor((this.latestRouteData.drivingTime / 3600));
            const minsDT = Math.floor(((this.latestRouteData.drivingTime % 3600) / 60));
            const secsDT = Math.floor(this.latestRouteData.drivingTime % 60);

            let formatedTime = "";
            formatedTime += "" + hrsDT + ":" + (minsDT < 10 ? "0" : "");
            formatedTime += "" + minsDT + ":" + (secsDT < 10 ? "0" : "");
            formatedTime += "" + secsDT;

            let distanceInMeter = this.latestRouteData.routeLength;
            if(distanceInMeter >= 1000) {
              distanceInMeter = distanceInMeter/1000;
              distanceInMeter = Math.round(distanceInMeter * 100) / 100;
              distanceInMeter += ' km';
            } else {
              distanceInMeter += ' m';
            }
            */

            const infoString = `${i18next.t('general.driving-time')} ${this.latestRouteData.formattedDrivingTime}<br>${i18next.t('general.route-length')} ${this.latestRouteData.formattedRouteLength}`;
            this.map.openTooltip(coordinate, infoString);
            shape.style.strokeWidth = 10;
          })
          .off('mouseleave')
          .on('mouseleave', (event) => {
            this.map.removeTooltip();
            shape.style.strokeWidth = 5;
          });
      });

    });

    $(this.map.getContainer()).on('contextmenu', (event) => {
      if (event.target.nodeName === 'polyline' || this.map.getOptions().getRightMouseAction() !== IWMapOptions.CONTROL_NONE) return;
      $('.editor-context-menu').hide();
      this.rightClickInfo = this.getClickInfo(event);

      const { x, y } = this.rightClickInfo.position;
      const currentWindowRec = this.map.getContainer().getBoundingClientRect();

      let posX = (x + 200) > currentWindowRec.width ? (x - 200) : x;
      let posY = (y + 114) > currentWindowRec.height ? (y-214) : y;

      const coordinatesString = `${this.rightClickInfo.coordinate.getY().toFixed(5)}, ${this.rightClickInfo.coordinate.getX().toFixed(5)}`;
      this.latestClick = this.rightClickInfo.coordinate.toString();
      this.geocoder.reverseGeocodeByHits(
        this.rightClickInfo.coordinate, 1,
        {
          type: constants.REVERSE_GEOCODING_RIGHT_CLICK_ON_MAP,
          triggeringPosition: this.latestClick,
        },
      );

      this.mapContextMenu.css({ left: posX, top: posY }).show();
      this.mapContextMenu.find('#addressDetails').html(coordinatesString);
      //$('#routing-add-start').addClass('disabled');
      //$('#routing-add-destination').addClass('disabled');
    });

    $('#routing-add-start').on('click', (event) => {
      event.preventDefault();
      this.setStartAddress(this.rightClickInfo.address, this.rightClickInfo.abstractAddress, false);
    });

    $('#routing-add-destination').on('click', (event) => {
      event.preventDefault();
      if(this.emergencyCircle) {
        IWRoutingManager._renderer.removeElement(this.emergencyCircle);
        this.emergencyCircle = null;
      }
      this.setEndAddress(this.rightClickInfo.address, this.rightClickInfo.abstractAddress, false);
    });
  }

  validateInput() {
    const startAddress = this.startAddressInput.val().length;
    const endAddress = this.endAddressInput.val().length;

    if (startAddress >= 2 && endAddress >= 2) {
      this.submitButton.prop('disabled', false);
      return true;
    }

    this.submitButton.prop('disabled', true);
    return false;
  }

  parseTruckRoutingAttributes() {

    return new Promise((resolve, reject) => {

      let truckAttributes = {};

      truckAttributes.vehicleWidth = this.truckAttributesRouting.find('#routing-truck-attribute-width').val();
      truckAttributes.vehicleHeight = this.truckAttributesRouting.find('#routing-truck-attribute-height').val();
      truckAttributes.vehicleWeight = (this.truckAttributesRouting.find('#routing-truck-attribute-weight').val()*1000).toString();
      truckAttributes.vehicleLength = this.truckAttributesRouting.find('#routing-truck-attribute-length').val();
      truckAttributes.vehicleAxles = this.truckAttributesRouting.find('#routing-truck-attribute-axleCount').val();
      truckAttributes.vehicleWeightPerAxle = (this.truckAttributesRouting.find('#routing-truck-attribute-axleWeight').val()*1000).toString();
      truckAttributes.vehicleLoadExplosive = this.truckAttributesRouting.find('#routing-truck-attribute-explosiveLoad').prop("checked") ? 1 : 0;
      truckAttributes.vehicleLoadHarmfulToWater = this.truckAttributesRouting.find('#routing-truck-attribute-harmfulLoad').prop("checked") ? 1 : 0;
      truckAttributes.vehicleLoadHazardous = this.truckAttributesRouting.find('#routing-truck-attribute-hazardLoad').prop("checked") ? 1 : 0;

      this.storage.putOption("truckProfile", truckAttributes)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });


    });
  }

  fillTruckProfile() {
    this.storage.getOption("truckProfile")
      .then(res => {
        if(res) {
          this.truckAttributesRouting.find('#routing-truck-attribute-width').val(res.vehicleWidth !== "0" ? res.vehicleWidth : '');
          this.truckAttributesRouting.find('#routing-truck-attribute-height').val(res.vehicleHeight !== "0" ? res.vehicleHeight : '');
          this.truckAttributesRouting.find('#routing-truck-attribute-weight').val(res.vehicleWeight !== "0" ? res.vehicleWeight/1000 : '');
          this.truckAttributesRouting.find('#routing-truck-attribute-length').val(res.vehicleLength !== "0" ? res.vehicleLength : '');
          this.truckAttributesRouting.find('#routing-truck-attribute-axleCount').val(res.vehicleAxles !== "0" ? res.vehicleAxles : '');
          this.truckAttributesRouting.find('#routing-truck-attribute-axleWeight').val(res.vehicleWeightPerAxle !== "0" ? res.vehicleWeightPerAxle/1000 : '');

          this.truckAttributesRouting.find('#routing-truck-attribute-explosiveLoad').prop("checked", parseInt(res.vehicleLoadExplosive) === 1);
          this.truckAttributesRouting.find('#routing-truck-attribute-harmfulLoad').prop("checked", parseInt(res.vehicleLoadHarmfulToWater) === 1);
          this.truckAttributesRouting.find('#routing-truck-attribute-hazardLoad').prop("checked", parseInt(res.vehicleLoadHazardous) === 1);
        }
      });
  }

  setRouteOptions() {
    return new Promise((resolve, reject) => {
      Promise.all([this.storage.getOption("truckRouting"), this.storage.getOption("truckProfile"), this.storage.getOption("useVehicleProfile"), this.storage.getOption("emergencyRouting"), this.storage.getOption("useTurnRestrictions"), this.storage.getOption("useTurnRestrictionsEmergency"), this.storage.getOption('tunnelRestrictionCode')])
        .then(result => {

          let truckRouting = result[0];
          const vehicleProfile = result[1];
          const useVehicleProfile = result[2];
          const useTurnRestrictions = result[4];
          const useTurnRestrictionsEmergency = result[5];
          const tunnelRestrictionCode = result[6];
          if(result[3]) {
            truckRouting = false;
          }

          let routeOptions = IWRoutingManager.getRouteOptions();
          if(truckRouting) {
            if(useVehicleProfile && vehicleProfile) {
              routeOptions.setTruckAttributes(vehicleProfile);
            } else {
              routeOptions.setTruckAttributes({});
            }
            routeOptions.setMobilityProfile("types_truck.txt");

          } else {
            if(useVehicleProfile && vehicleProfile) {
              routeOptions.setTruckAttributes(vehicleProfile);
            } else {
              routeOptions.setTruckAttributes({});
            }
            routeOptions.setMobilityProfile("types_fast.txt");
          }

          routeOptions.setUseTurnRestrictionsForNormalRoutes(useTurnRestrictions);
          routeOptions.setUseTurnRestrictionsForEmergencyRoutes(useTurnRestrictionsEmergency);

          if(tunnelRestrictionCode) {
            routeOptions.setTunnelRestrictionCode(tunnelRestrictionCode);
          } else {
            routeOptions.setTunnelRestrictionCode('');
          }

          IWRoutingManager.setRouteOptions(routeOptions);
          resolve();
        });
    });
  }

  getClickInfo(event) {
    const mapBoundingClientRect = this.map.getContainer().getBoundingClientRect();

    const position = {
      x: event.pageX,
      y: event.pageY,
    };

    const mapPosition = {
      x: event.pageX - mapBoundingClientRect.left,
      y: event.pageY - mapBoundingClientRect.top,
    };

    const coordinate = this.map.getCurrentMapType().getProjection()
      .pixelToMeter(new IWPoint(mapPosition.x, mapPosition.y))
      .toWGS84();

    const abstractAddress = new IWAddress('', '', '', '', '', '', '', coordinate);

    return {
      abstractAddress,
      coordinate,
      position,
    };
  }

  removeMarkerFromMap(marker) {
    this.map.getOverlayManager().getLayer(constants.ROUTE_MARKERS_LAYER_ID).removeOverlay(marker);
  }

  addMarkerOnMap(address, iconFile) {
    const icon = new IWIcon(`img/${iconFile}`, new IWPoint(11, 32), new IWSize(23, 32));

    // noinspection JSCheckFunctionSignatures
    const marker = new IWMarker(this.map, address.getCoordinate());

    marker.setDefaultIcon(icon);

    this.map.getOverlayManager().getLayer(constants.ROUTE_MARKERS_LAYER_ID).addOverlay(marker);

    return marker;
  }

  removeCurrentRoute() {
    if(this.destinationMarker) this.removeMarkerFromMap(this.destinationMarker);
    if(this.startMarker) this.removeMarkerFromMap(this.startMarker);

    this.destinationMarker = null;
    this.startMarker = null;

    IWRoutingManager.clearRoute();

    if(this.emergencyCircle) {
      IWRoutingManager._renderer.removeElement(this.emergencyCircle);
      this.emergencyCircle = null;
    }
    this.totalGeocodedAddress = 0;

    this.isDestinationAddressSet = false;
    this.isStartAddressSet = false;
  }

  updateEmergencyRoutingData() {

    return new Promise((resolve, reject) => {

      this.storage.getOption("emergencyRouting")
        .then((result) => {
          this.useEmergencyRouting = result;
          if(!this.useEmergencyRouting) {
            this.useEmergencyRouting = false;
          }

          this.storage.getOption("emergencyRadius")
            .then((result) => {
              if(!isNaN(result) && result) {
                this.emergencyRadius = parseInt(result);
              } else {
                this.emergencyRadius = 0;
              }

              if(this.useEmergencyRouting) {
                IWRoutingManager.getRouteOptions().setEmergencyRoutingRadius(this.emergencyRadius);
              } else {
                IWRoutingManager.getRouteOptions().setEmergencyRoutingRadius(0);
              }
              resolve(null);
            });
        });
    });
  }

  populateCountriesList() {
    Object.keys(this.countries.iwCountries).forEach(function (code) {
      this.countrySelectorStart.append($("<option>").val(code).text(this.countries.iwCountries[code]));
      this.countrySelectorEnd.append($("<option>").val(code).text(this.countries.iwCountries[code]));
    }.bind(this));

    this.storage.getOption("countrySelectorStart")
      .then((result) => {
        let defaultCountryStart = result;
        if(!defaultCountryStart) defaultCountryStart = "deu";
        this.countrySelectorStart.val(defaultCountryStart);
      });

    this.storage.getOption("countrySelectorEnd")
      .then((result) => {
        let defaultCountryEnd = result;
        if(!defaultCountryEnd) defaultCountryEnd = "deu";
        this.countrySelectorEnd.val(defaultCountryEnd);
      });

  }

  downloadRoute() {
    let rowSeparator = ';';
    let header = ['latitude', 'longitude'];

    let output = header.join(rowSeparator) + '\n';

    this.latestRouteCoords.forEach((coord, index) => {
      let wgsCoord = coord.toWGS84();
      var outputArray = [
        wgsCoord.getY(),
        wgsCoord.getX()
      ];
      output += outputArray.join(rowSeparator) + '\n';
    });

    let date = new Date();

    let blob = new Blob(['\ufeff' + output], {type: 'text/txt'});
    let filename = date.toLocaleDateString() + "_" + date.toLocaleTimeString('de-DE') +  "-routing" +  '.csv';

    var elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);

    return output;
  };
}

module.exports = AddressRouting;
